import script from "./PrescricaoModalAtendimento.vue?vue&type=script&setup=true&lang=js"
export * from "./PrescricaoModalAtendimento.vue?vue&type=script&setup=true&lang=js"

import "./PrescricaoModalAtendimento.vue?vue&type=style&index=0&id=450f3ec2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450f3ec2"]])

export default __exports__